import { useState } from "react";

function Contact() {
    const [form, setForm] = useState({
        name: "",
        company: "",
        email: "",
        message: ""
    }); 
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMsg("");
        setSubmitted(false);


        try {
            const res = await fetch(`/api/contact`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form)
            });

            const data = await res.json().catch(() => ({}));

            if (!res.ok) {
                throw new Error(data.message || "Senden fehlgeschlagen");
            }

            setSubmitted(true);
            setForm({ name: "", company: "", email: "", message: "" });
        } catch (error) {
            setErrorMsg(error.message || "Unbekannter Fehler." );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id="contact" className="max-w-3xl mx-4 md:mx-auto mt-12 md:mt-16">
            <div className="glass-card p-6 md:p-8 text-left">


            <h2 className="text-3xl font-black mb-6 text-slate-900">Kontaktformular</h2>


            {submitted && (
                <div className="text-green-600 font-semibold mb-4">
                Vielen Dank für Ihre Nachricht!
                </div>
            )}

            {errorMsg && (
                <div className="text-red-600 font-semibold mb-4">
                {errorMsg}
                </div>
            )}

                <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                    <input
                        type="text"
                        name="name"
                        placeholder="Name"
                        value={form.name}
                        onChange={handleChange}
                        required
                        className="border border-slate-300 bg-white/70 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500"
                    />
                    <input
                        type="text"
                        name="company"
                        placeholder="Unternehmen"
                        value={form.company}
                        onChange={handleChange}
                        className="border border-slate-300 bg-white/70 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500"
                    />
                    <input
                        type="email"
                        name="email"
                        placeholder="E-Mail"
                        value={form.email}
                        onChange={handleChange}
                        required
                        className="border border-slate-300 bg-white/70 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500"
                    />
                    <textarea
                        name="message"
                        placeholder="Anliegen"
                        value={form.message}
                        onChange={handleChange}
                        required
                        className="border border-slate-300 bg-white/70 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500"
                    />
                    <button
                        type="submit"
                        className="bg-slate-900 text-white font-bold py-3 px-4 rounded-lg hover:bg-cyan-700 transition-colors disabled:opacity-60"
                        
                        disabled={loading}> Absenden
                    </button>
                </form>
            
            </div>
        </div>
    );
}

export default Contact;
